import { APIFetch } from "src/APIFetch";
import { IPartsBlockedStatus } from "online-services-types";

export const fetchPartsBlockedStatus = async () => {
  return new APIFetch<IPartsBlockedStatus>("spareparts/blocking-data").get();
};
